import React from "react";

const FaqSection = () => {
  return (
    <section id="faq" className="faq section-bg">
      <div className="container" data-aos="fade-up">
        <div className="section-title">
          <h2>F.A.Q</h2>
          <h3>
            <span>Preguntas</span> frecuentes
          </h3>
          <p>
            Encuentra respuestas a las preguntas más comunes sobre nuestra
            plataforma.
          </p>
        </div>
        <div className="row justify-content-center">
          <div className="col-xl-10">
            <ul className="faq-list">
              <li>
                <div
                  data-bs-toggle="collapse"
                  className="collapsed question"
                  href="#faq1"
                >
                  ¿Cuál es el costo de utilizar este servicio?{" "}
                  <i className="bi bi-chevron-down icon-show"></i>
                  <i className="bi bi-chevron-up icon-close"></i>
                </div>
                <div id="faq1" className="collapse" data-bs-parent=".faq-list">
                  <p>
                    Actualmente ofrecemos una versión gratuita de nuestra
                    plataforma que te permite crear un torneo y programar hasta
                    tres fechas sin costo alguno. Para acceder a funcionalidades
                    adicionales y programar un número ilimitado de fechas,
                    ofrecemos una suscripción mensual por un costo de 10.000
                    pesos argentinos.
                  </p>
                </div>
              </li>
              <li>
                <div
                  data-bs-toggle="collapse"
                  className="collapsed question"
                  href="#faq2"
                >
                  ¿La plataforma ofrece opciones de comunicación entre los
                  organizadores y los participantes?{" "}
                  <i className="bi bi-chevron-down icon-show"></i>
                  <i className="bi bi-chevron-up icon-close"></i>
                </div>
                <div id="faq2" className="collapse" data-bs-parent=".faq-list">
                  <p>
                    Actualmente, nuestra plataforma no ofrece opciones de
                    comunicación directa entre los organizadores y los
                    participantes. Sin embargo, estamos trabajando en una
                    actualización que permitirá informar todas las novedades del
                    torneo directamente a través de la página. Además, esta
                    actualización permitirá a los equipos modificar su
                    disponibilidad, lo que aliviará la carga de responsabilidad
                    del organizador.
                  </p>
                </div>
              </li>
              <li>
                <div
                  data-bs-toggle="collapse"
                  className="collapsed question"
                  href="#faq3"
                >
                  ¿Cómo puedo crear un nuevo torneo o evento en la plataforma?{" "}
                  <i className="bi bi-chevron-down icon-show"></i>
                  <i className="bi bi-chevron-up icon-close"></i>
                </div>
                <div id="faq3" className="collapse" data-bs-parent=".faq-list">
                  <p>
                    Para crear un nuevo torneo o evento en nuestra plataforma,
                    simplemente necesitas <a href="/signup">registrarte</a> y
                    comenzar a utilizar la plataforma. Una vez que hayas creado
                    una cuenta, podrás acceder a todas las funciones de creación
                    de torneos y eventos disponibles en nuestra plataforma y
                    comenzar a planificar tu próximo evento deportivo de manera
                    fácil y rápida.
                  </p>
                </div>
              </li>
              <li>
                <div
                  data-bs-toggle="collapse"
                  className="collapsed question"
                  href="#faq4"
                >
                  ¿Qué tipo de información debo proporcionar al crear un torneo?{" "}
                  <i className="bi bi-chevron-down icon-show"></i>
                  <i className="bi bi-chevron-up icon-close"></i>
                </div>
                <div id="faq4" className="collapse" data-bs-parent=".faq-list">
                  <p>
                    Al crear un torneo, es importante proporcionar la siguiente
                    información:
                    <br></br>- Lista de equipos participantes.
                    <br></br>- Turnos disponibles para jugar, incluyendo día,
                    hora y cancha.
                    <br></br>- Disponibilidad de los equipos para cada turno.
                    <br></br> <br></br>
                    Esta información se debe ingresar una sola vez y quedará
                    guardada para las siguientes fechas del torneo, lo que
                    facilita la planificación y organización continua del
                    evento.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
